import React, { useState } from 'react';
import './Pagination.css';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  isLimited?: boolean;
  maxAllowed?: number;
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  isLimited = false,
  maxAllowed = 0,
}) => {
  const [tooltipPage, setTooltipPage] = useState<number | null>(null);

  if (totalPages <= 1) return null;

  // 페이지 번호 생성 (현재 페이지 주변 5개)
  const getPageNumbers = () => {
    const pages = [];
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }
    if (endPage > totalPages) {
      endPage = totalPages;
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  // 제한된 경우 1페이지만 활성화
  const isPageDisabled = (page: number) => {
    return isLimited && page > 1;
  };

  const handlePageClick = (page: number) => {
    if (!isPageDisabled(page)) {
      onPageChange(page);
    }
  };

  return (
    <div className="pagination">
      <button
        onClick={() => handlePageClick(1)}
        disabled={currentPage === 1 || (isLimited && currentPage > 1)}
        className="page-btn first"
      >
        &lt;&lt;
      </button>
      <button
        onClick={() => handlePageClick(currentPage - 1)}
        disabled={currentPage === 1 || (isLimited && currentPage > 1)}
        className="page-btn prev"
      >
        &lt;
      </button>

      {getPageNumbers().map((page) => {
        const disabled = isPageDisabled(page);
        return (
          <div
            key={page}
            className="page-num-wrapper"
            onMouseEnter={() => disabled && setTooltipPage(page)}
            onMouseLeave={() => setTooltipPage(null)}
          >
            <button
              onClick={() => handlePageClick(page)}
              disabled={disabled}
              className={`page-num ${currentPage === page ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
            >
              {page}
            </button>
            {tooltipPage === page && disabled && (
              <div className="pagination-tooltip">
                현재 버전은 {maxAllowed}개까지만 조회가능합니다
              </div>
            )}
          </div>
        );
      })}

      <button
        onClick={() => handlePageClick(currentPage + 1)}
        disabled={currentPage === totalPages || isLimited}
        className="page-btn next"
      >
        &gt;
      </button>
      <button
        onClick={() => handlePageClick(totalPages)}
        disabled={currentPage === totalPages || isLimited}
        className="page-btn last"
      >
        &gt;&gt;
      </button>
    </div>
  );
};


